import Airtable from 'airtable';
import config from '../../config';

export const createAirTableClient = (baseId: string) => {
  return new Airtable({
    apiKey: config.airtablePAT,
  }).base(baseId);
};

export const createVenuesBaseClient = () =>
  createAirTableClient(config.airtableVenuesBaseId);
